import * as React from 'react';

function useModal() {
  const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  return {
    modalIsOpen,
    openModal,
    closeModal
  };
}

export default useModal;
